import CONSTANTS from './CONSTANTS';

export const selectedLanguage = () => {
  let language;

  if (CONSTANTS.language === 'en') {
    language = CONSTANTS.stroop.coloursEnglish;
  } else if (CONSTANTS.language === 'nl') {
    language = CONSTANTS.stroop.coloursDutch;
  } else if (CONSTANTS.language === 'de') {
    language = CONSTANTS.stroop.coloursGerman;
  } else if (CONSTANTS.language === 'uk') {
    language = CONSTANTS.stroop.coloursUkrainian;
  } else {
    language = CONSTANTS.stroop.coloursEnglish;
  }

  return language;
};
